// extracted by mini-css-extract-plugin
export default {"breadcrumbContainer":"styles_breadcrumbContainer__ivny0"};